import React from 'react'
import { ICONS } from '@Const/common'
import { WorkModel } from '@Entities/work/work'
import WorkItemsSimpleTable from '@Components/Tables/WorkItemsSimpleTable'
import { FileReviewExpandWorks } from '@Scenes/WorkScenes/Steps/FileReviewStep/file-review-expand-works'

interface FileReviewCompletedWorksProps {
    readyWorksExpanded: boolean
    expandSection: (section: FileReviewExpandWorks) => void
    contractSection: (section: FileReviewExpandWorks) => void
    numComplete: number
    completedWorks: WorkModel[]
}

const FileReviewCompletedWorks = (props: FileReviewCompletedWorksProps) => {
    const { readyWorksExpanded, expandSection, contractSection, numComplete, completedWorks } = props

    return (
        <section className="items-container">
            <div
                className="items-header"
                onClick={() => {
                    readyWorksExpanded
                        ? contractSection(FileReviewExpandWorks.ready)
                        : expandSection(FileReviewExpandWorks.ready)
                }}
            >
                <p className="type-title bold">Ready to Submit ( {numComplete} )</p>
                {readyWorksExpanded
                    ? numComplete && <img src={ICONS.minus} alt="contract" />
                    : numComplete && <img src={ICONS.add} alt="expand" />}
            </div>
            {readyWorksExpanded && <WorkItemsSimpleTable workModelList={completedWorks} valid />}
        </section>
    )
}

export default FileReviewCompletedWorks
